const DEFAULT_PUBLIC_CONTACT_EMAIL = 'contact@taijitsu-dromois.fr'
const TURNSTILE_TEST_SITE_KEY = '1x00000000000000000000AA'
const runtimeConfig = typeof window === 'undefined' ? undefined : window.__TAIJITSU_CONFIG__

export const PUBLIC_CONTACT_EMAIL = (
  runtimeConfig?.VITE_PUBLIC_CONTACT_EMAIL
  || import.meta.env.VITE_PUBLIC_CONTACT_EMAIL
  || DEFAULT_PUBLIC_CONTACT_EMAIL
).trim()

export const TURNSTILE_SITE_KEY = (
  runtimeConfig?.VITE_TURNSTILE_SITE_KEY
  || import.meta.env.VITE_TURNSTILE_SITE_KEY
  || (import.meta.env.DEV ? TURNSTILE_TEST_SITE_KEY : '')
).trim()
